import { Component } from "react";
import * as React from "react";
import { Dropdown, IDropdownOption, MessageBarType } from "office-ui-fabric-react";
import ApiService from "./ApiService";
import { IRootState } from "../store";
import { connect, DispatchProp } from "react-redux";
import Actions from "../redux/Actions";
import DispatchProps from "../utils/DispatchProps";


export interface CommunicationSiteTemplateSelectorProps {
    className: string;
    selectedTemplateName?: string;
    disabled: boolean;
    onChanged(selectedTemplateName: string): void;

    tenantId: string;
    schoolCode: string;
    
    apiService: ApiService;
}

export interface CommunicationSiteTemplateSelectorState {
    loading: boolean;
    templateOptions: IDropdownOption[];
}

class CommunicationSiteTemplateSelector extends Component<CommunicationSiteTemplateSelectorProps & DispatchProps, CommunicationSiteTemplateSelectorState>
{
    constructor(props: Readonly<CommunicationSiteTemplateSelectorProps & DispatchProps>) {
        super(props);

        this.state = {
            loading: false,
            templateOptions: []
        };
    }

    async componentDidUpdate(prevProps: Readonly<CommunicationSiteTemplateSelectorProps & DispatchProp>, prevState: Readonly<CommunicationSiteTemplateSelectorState>, snapshot?: any): Promise<void> {
        
    }

    public async componentDidMount() {
        try {
            this.setState({ loading: true, templateOptions: [] });

            var templates = await this.props.apiService.getCreateSiteTemplates(this.props.tenantId,this.props.schoolCode);

            var templateOptions = templates.map(t => {
                return {
                    key: t.key!,
                    text: t.displayName!
                }
            });

            this.setState({ loading: false, templateOptions: templateOptions });
        }
        catch (e) {
            this.setState({ loading: false });
            this.props.dispatch(Actions.showMessageBar(`Error loading Site Templates`, MessageBarType.error));
        }
    }

    public render() {
        return (
            <Dropdown
                className={this.props.className}
                label="Site Template"
                disabled={this.props.disabled || this.state.loading}
                selectedKey={this.props.selectedTemplateName}
                onChange={(e, o) => this.props.onChanged(o?.key as string)}
                placeholder={"Select a Site Template"}
                options={this.state.templateOptions}
                styles={{ dropdown: { width: 300 } }}
            />
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { className: string, selectedTemplateName?: string, disabled: boolean, onChanged(selectedTemplateName: string): void ,tenantId: string,schoolCode: string}): CommunicationSiteTemplateSelectorProps => {
        return {
            className: ownProps.className,
            selectedTemplateName: ownProps.selectedTemplateName,
            disabled: ownProps.disabled,
            onChanged: ownProps.onChanged,
            tenantId: ownProps.tenantId,
            schoolCode: ownProps.schoolCode,
            apiService: state.auth.apiService,
        };
    }
)(CommunicationSiteTemplateSelector)